/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "gnss_solver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Quality {
}

export enum Quality_Enum {
  UNKNOWN = 0,
  DEGRADED = 1,
  HEALTHY = 2,
  UNRECOGNIZED = -1,
}

export function quality_EnumFromJSON(object: any): Quality_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return Quality_Enum.UNKNOWN;
    case 1:
    case "DEGRADED":
      return Quality_Enum.DEGRADED;
    case 2:
    case "HEALTHY":
      return Quality_Enum.HEALTHY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Quality_Enum.UNRECOGNIZED;
  }
}

export function quality_EnumToJSON(object: Quality_Enum): string {
  switch (object) {
    case Quality_Enum.UNKNOWN:
      return "UNKNOWN";
    case Quality_Enum.DEGRADED:
      return "DEGRADED";
    case Quality_Enum.HEALTHY:
      return "HEALTHY";
    case Quality_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseQuality(): Quality {
  return {};
}

export const Quality = {
  encode(_: Quality, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Quality {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuality();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Quality {
    return {};
  },

  toJSON(_: Quality): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Quality>, I>>(base?: I): Quality {
    return Quality.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Quality>, I>>(_: I): Quality {
    const message = createBaseQuality();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
